import { createStore } from 'vuex';

// 动态加载 modules 文件夹下的所有模块
const requireModule = require.context('./modules', false, /\.js$/);
const modules = {};

requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1');
  const module = requireModule(fileName).default;

  // 统一开启命名空间
  modules[moduleName] = {
    ...module,
    namespaced: true
  };
});

const store = createStore({
  modules
});

export default store;